<template>
  <div>
    <el-row style="height: 60px">
      <el-col :span="24">
        <el-button type="primary" size="small" @click="showImport=true" style="margin-right: 15px">导入订单</el-button>

        <el-button type="primary" size="small" @click="sendGoods">批量延长收货时间</el-button>

        <el-link href="./static/template/yanchang.xls"  type="primary" style="margin-left: 20px">批量延长时间模板</el-link>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border :data="delayData"  style="font-size: 12px" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '0px'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="260px"></el-table-column>
          <el-table-column  prop="days" label="延长时间" width="100px"></el-table-column>
          <el-table-column  prop="status" label="状态" ></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="导入订单" :close-on-click-modal="false"
      :visible.sync="showImport"
      width="50%"
      center>
      <span style="margin-left:20px; margin-bottom: 30px">复制Excel表格里的订单，在这里粘贴 （格式：订单号  延时天数） </span>
      <el-input :rows="15" type="textarea" v-model="delayTxt"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="uploadData">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"
  import copy from "../api/copy"

  export default {
    name: "Delay",
    data(){
      return{
        deny:0,
        showImport:false,
        delayTxt:'',
        delayData:[],
        sendValue:'offline',
        sendOpto:[{label:'虚拟发货',value:'dummy'},{label:'自己联系',value:'offline'},{label:'线上物流',value:'online'}]

      }
    },
    methods:{
      indexMethod(index)
      {
        return index + 1;
      },
      getDelayData:function () {
        let param={
          nick:storage.get("nick"),
        }
        $api.post("/delay/get", param, response =>{
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.delayData = dataResult.data;
          }
          else{
            this.$message.error(dataResult);
            this.deny = 1;
          }
        })
      },
      uploadData:function () {
        this.showImport = false;
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        let param={
          nick:storage.get("nick"),
          txt: this.delayTxt
        }
        $api.post("/delay/import", param, response =>{
          console.log(response)
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.delayTxt = '';
            this.getDelayData();
            console.log("end.")
          }
          else{
            this.$message.error(dataResult);
          }
        })
      },
      sendGoods:function () {
        if(this.delayData.length == 0){
          this.$message.error("没有订单数据，请先导入订单后再延长时间！。");
          return;
        }
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        let param={
          nick:storage.get("nick"),
        }
        $api.post("/delay/update", param, response =>{
          console.log(response)
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){

            this.getDelayData();
            this.$message.success("批量延长收货时间完成。")
          }
          else{
            this.$message.error(dataResult.data.message);
          }
        })
      }
    },
    mounted(){
      this.getDelayData();
    }
  }
</script>

<style >

</style>




// WEBPACK FOOTER //
// src/page/Delay.vue